import api from './api';

/**
 * Skip Visit Management page APIs — not Study Configuration / SiteController.
 */
const siteVisitAssignmentService = {
  async getSites(projectCode) {
    const response = await api.get('/SiteVisitAssignment/sites', {
      params: { projectCode },
    });
    return response.data;
  },

  async getSelections(projectCode, siteId) {
    const response = await api.get('/SiteVisitAssignment/selections', {
      params: { projectCode, siteId },
    });
    return response.data;
  },

  async saveSelections({ projectCode, siteId, studyVisitTypeNos, baseProfileCode = 'CRA', remark = null }) {
    const response = await api.post('/SiteVisitAssignment/selections', {
      projectCode,
      siteId,
      studyVisitTypeNos,
      baseProfileCode,
      remark,
    });
    return response.data;
  },
};

export default siteVisitAssignmentService;
